import type { DeskTab } from '../../../lib/deskPeriod'

/** The Visitors Desk user manual's sections, in order. Ids are linked from the desk (TAB_HELP): rename one there too. */
export const CONTENTS: [string, string][] = [
  ['start', 'Start here'],
  ['words', 'The words it uses'],
  ['summary', 'Summary and the analyst'],
  ['today', 'Today'],
  ['sources', 'Sources'],
  ['search', 'Search'],
  ['flows', 'Flows'],
  ['articles', 'Articles'],
  ['issues', 'Issues'],
  ['audience', 'Audience'],
  ['trends', 'Trends'],
  ['revenue', 'Revenue'],
  ['alerts', 'Alerts and the weekly digest'],
  ['settings', 'Desk settings'],
  ['access', 'Who sees what'],
  ['faq', 'Questions and problems'],
]

/** The manual section each tab's "How this works" link opens. */
export const TAB_HELP: Record<DeskTab, string> = {
  today: 'today',
  sources: 'sources',
  search: 'search',
  flows: 'flows',
  articles: 'articles',
  issues: 'issues',
  audience: 'audience',
  trends: 'trends',
  revenue: 'revenue',
}

/** The manual, or one section of it. */
export function manualHref(section?: string): string {
  return `/visitors/desk/help${section ? `#${section}` : ''}`
}
